import Box from "@mui/material/Box";
import {Typography} from "@mui/material";
import {
    compositionMediaModulePanelSx,
    mediaModuleSectionColumnsSx,
    mediaModuleSectionRowSx,
    mediaModuleSectionTitleSx,
} from "../../../components/composition/CompositionMediaView";
import {compositionMediaModulePanelInCardSx} from "../../../components/composition/compositionMediaLayoutSx";
import {getContactsPageFieldGroups} from "../../../utils/contactsPageFields";
import {isKuhniVersoMebelDomain} from "../../../utils/isKuhniVersoMebelDomain";
import {
    getPersonalizationFieldLabelSx,
    personalizationFieldRowSx,
    personalizationReadOnlyValueSx,
    personalizationReadOnlyValueTextSx,
} from "./orderPersonalizationFieldLayout";

const {left: LEFT_FIELDS, right: RIGHT_FIELDS} = getContactsPageFieldGroups();

const renderReadOnlyFieldRow = ({key, label, value}, column) => (
    <Box key={key} sx={personalizationFieldRowSx}>
        <Typography sx={getPersonalizationFieldLabelSx(column)}>{label}</Typography>
        <Box sx={personalizationReadOnlyValueSx} role="textbox" aria-readonly="true" aria-label={label}>
            <Typography component="div" sx={personalizationReadOnlyValueTextSx}>
                {value}
            </Typography>
        </Box>
    </Box>
);

const OrderCustomerContactsCard = () => (
    <Box
        sx={{
            ...compositionMediaModulePanelSx,
            ...compositionMediaModulePanelInCardSx,
        }}
    >
        <Typography sx={mediaModuleSectionTitleSx}>
            {isKuhniVersoMebelDomain() ? "Реквизиты продавца" : "Данные поставщика"}
        </Typography>
        <Box sx={{...mediaModuleSectionRowSx, mt: "16px"}}>
            <Box sx={mediaModuleSectionColumnsSx}>
                {LEFT_FIELDS.map((field) => renderReadOnlyFieldRow(field, "left"))}
            </Box>
            <Box sx={mediaModuleSectionColumnsSx}>
                {RIGHT_FIELDS.map((field) => renderReadOnlyFieldRow(field, "right"))}
            </Box>
        </Box>
    </Box>
);

export default OrderCustomerContactsCard;
